var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4727 5.49902H7.47266C6.92037 5.49902 6.47266 5.94674 6.47266 6.49902V12.499C6.47266 13.0513 6.92037 13.499 7.47266 13.499H13.4727C14.0249 13.499 14.4727 13.0513 14.4727 12.499V6.49902C14.4727 5.94674 14.0249 5.49902 13.4727 5.49902Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4727 17.499H7.47266C6.92037 17.499 6.47266 17.9467 6.47266 18.499V24.499C6.47266 25.0513 6.92037 25.499 7.47266 25.499H13.4727C14.0249 25.499 14.4727 25.0513 14.4727 24.499V18.499C14.4727 17.9467 14.0249 17.499 13.4727 17.499Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 5.49902H18.4727C17.9204 5.49902 17.4727 5.94674 17.4727 6.49902V12.499C17.4727 13.0513 17.9204 13.499 18.4727 13.499H24.4727C25.0249 13.499 25.4727 13.0513 25.4727 12.499V6.49902C25.4727 5.94674 25.0249 5.49902 24.4727 5.49902Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 17.499V21.499",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4727 25.499H21.4727V17.499",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4727 19.499H25.4727",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4727 23.499V25.499",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53125 6.51038V5.48974C2.53125 4.38518 3.42668 3.48975 4.53125 3.48975H5.4695",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 25.4896V26.5103C29.4688 27.6148 28.5733 28.5103 27.4687 28.5103H26.5305",
    stroke: "white",
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4688 6.51038V5.48974C29.4688 4.38518 28.5733 3.48975 27.4687 3.48975H26.5305",
    stroke: "white",
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53125 25.4896V26.5103C2.53125 27.6148 3.42668 28.5103 4.53125 28.5103H5.4695",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.52efdd98a9a2495d4ec42b5abd26084f.svg";
export { ForwardRef as ReactComponent };